<ng-container *ngIf="product?.generalInfoMap">
    <div class="TabBody">
        <ng-container *ngIf="product?.descriptionText">
            <div class="description-wrapper">
                <div class="description-content">
                    <h2 class="description-header">
                        {{'common.description_text'| cxTranslate}}
                    </h2>

                    <div class="value value-padding" [innerHTML]="getSanitizedHtml(product?.descriptionText)">
                    </div>
                </div>
            </div>
        </ng-container>
        <div class=" col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="tab-details general-info-tab row">
                <div class="col-xs-12 col-sm-6 general-info-left-content" *ngIf="isAnyGeneralInfoAvailable(product)">
                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_weight_dimensions'">
                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValues(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key | cxTranslate}}</span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value "> {{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>

                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_packaging'">

                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValues(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key | cxTranslate}}</span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value "> {{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>

                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_vrms'">

                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValuesVrm(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key}}</span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value">{{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>

                </div>

                <div class="col-xs-12 col-sm-6 general-info-left-content">
                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_coreInformation'">

                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValues(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key | cxTranslate}}</span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value">{{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>
                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_customsInfo'">

                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValues(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key | cxTranslate}}&nbsp;<span class="as-red">*</span></span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value as-red">* {{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>
                    <ng-container *ngFor="let info of product?.generalInfoMap">
                        <ng-container *ngIf="info.key=='common.text_generalInfo_customTarrifNo'">

                            <h2 class="pdp-tab-header bottom-margin-zero">{{info.key | cxTranslate}}</h2>
                            <ng-container *ngFor="let item of getObjectValues(info.value)">
                                <ng-container *ngIf="!(item.key.includes('use only value'));else SubjectTemplate">
                                    <div class="bottom-border row">
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <span>{{item.key | cxTranslate}}&nbsp;<span class="as-red">*</span></span>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 padding-7">
                                            <div class="value">{{item.value}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #SubjectTemplate>
                                    <div class="bottom-border row">
                                        <div class="col-xs-12 col-sm-12 padding-7">
                                            <div class="value as-red">* {{item.value | cxTranslate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

</ng-container>